<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
        body {
            margin: 0;
            padding: 0;
            min-height: 10vh;
            display: flex;
            flex-direction: column;
        }

        .footer {
            position: fixed;
            bottom: 0;
            width: 100%;
            background-color: #f8f9fa; /* You can change the background color as needed */
            border-top: 1px solid #dee2e6; /* You can add a border if desired */
        }

        .footer-content {
            display: flex;
            flex-direction: column;
            align-items: center; /* Center horizontally */
            justify-content: center; /* Center vertically */
            padding: 10px;
            text-align: center; /* Center text within the container */
        }

        .footer-content a {
            color: inherit;
            text-decoration: none;
        }
    </style>
</head>
<body>
    <!-- Your page content goes here -->

    <footer class="footer">
        <div class="footer-content">
            <div class="text-muted">
                Copyright © {{CurrentDate}} Aptara Inc. All Rights Reserved. | Privacy Policy
            </div>
        </div>
    </footer>
</body>
</html>
